// ============ INTELLIGENT RECIPE IMAGE MAPPING ============
// Images based on MAIN INGREDIENT, not random category

const INGREDIENT_IMAGES = {
  // Proteins
  'pollo': 'https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?w=400',
  'pechuga': 'https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?w=400',
  'pavo': 'https://images.unsplash.com/photo-1606728035253-49e8a23146de?w=400',
  'ternera': 'https://images.unsplash.com/photo-1588168333986-5078d3ae3976?w=400',
  'carne': 'https://images.unsplash.com/photo-1588168333986-5078d3ae3976?w=400',
  'salmón': 'https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=400',
  'salmon': 'https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=400',
  'atún': 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400',
  'atun': 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400',
  'merluza': 'https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?w=400',
  'pescado': 'https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?w=400',
  'gambas': 'https://images.unsplash.com/photo-1565680018434-b513d5e5fd47?w=400',
  'huevo': 'https://images.unsplash.com/photo-1525351484163-7529414344d8?w=400',
  'claras': 'https://images.unsplash.com/photo-1525351484163-7529414344d8?w=400',
  
  // Carbs
  'arroz': 'https://images.unsplash.com/photo-1536304993881-ff6e9eefa2a6?w=400',
  'pasta': 'https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?w=400',
  'quinoa': 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=400',
  'avena': 'https://images.unsplash.com/photo-1517673400267-0251440c45dc?w=400',
  'tortitas': 'https://images.unsplash.com/photo-1528207776546-365bb710ee93?w=400',
  'pancakes': 'https://images.unsplash.com/photo-1528207776546-365bb710ee93?w=400',
  'tostada': 'https://images.unsplash.com/photo-1525351484163-7529414344d8?w=400',
  'patata': 'https://images.unsplash.com/photo-1518977676601-b53f82ber903?w=400',
  'boniato': 'https://images.unsplash.com/photo-1596097635121-14b63b7a0c19?w=400',
  
  // Bowls & Salads
  'bowl': 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=400',
  'poke': 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400',
  'ensalada': 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=400',
  'wrap': 'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?w=400',
  
  // Dairy & Protein
  'yogur': 'https://images.unsplash.com/photo-1488477181946-6428a0291777?w=400',
  'queso': 'https://images.unsplash.com/photo-1486297678162-eb2a19b0a32d?w=400',
  'proteína': 'https://images.unsplash.com/photo-1593095948071-474c5cc2989d?w=400',
  'whey': 'https://images.unsplash.com/photo-1593095948071-474c5cc2989d?w=400',
  'batido': 'https://images.unsplash.com/photo-1553530666-ba11a7da3888?w=400',
  'smoothie': 'https://images.unsplash.com/photo-1553530666-ba11a7da3888?w=400',
  
  // Fruits & Veggies
  'acai': 'https://images.unsplash.com/photo-1590301157890-4810ed352733?w=400',
  'fruta': 'https://images.unsplash.com/photo-1490474418585-ba9bad8fd0ea?w=400',
  'verduras': 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=400',
  'brócoli': 'https://images.unsplash.com/photo-1459411552884-841db9b3cc2a?w=400',
  
  // Sweets & Snacks
  'brownie': 'https://images.unsplash.com/photo-1606313564200-e75d5e30476c?w=400',
  'muffin': 'https://images.unsplash.com/photo-1607958996333-41aef7caefaa?w=400',
  'bizcocho': 'https://images.unsplash.com/photo-1606313564200-e75d5e30476c?w=400',
  'postre': 'https://images.unsplash.com/photo-1551024506-0bccd828d307?w=400',
  'snack': 'https://images.unsplash.com/photo-1599490659213-e2b9527bd087?w=400',
  
  // Specific dishes
  'albóndiga': 'https://images.unsplash.com/photo-1529042410759-befb1204b468?w=400',
  'hamburguesa': 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=400',
  'revuelto': 'https://images.unsplash.com/photo-1525351484163-7529414344d8?w=400',
  'tortilla': 'https://images.unsplash.com/photo-1525351484163-7529414344d8?w=400',
  'fajita': 'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?w=400',
  'taco': 'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?w=400',
  'crema': 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=400',
  'sopa': 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=400',
};

// Default premium placeholder
const DEFAULT_IMAGE = 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=400';

/**
 * Get image URL based on recipe name and ingredients
 * Prioritizes: recipe.image (admin) > recipe.imagen (legacy) > ingredient match > default
 */
export const getRecipeImage = (recipe) => {
  // 1. If recipe has a custom image from admin (image field), use it
  if (recipe.image) return recipe.image;
  
  // 2. Legacy support: check imagen field
  if (recipe.imagen) return recipe.imagen;
  
  const nombre = (recipe.nombre || '').toLowerCase();
  
  // 2. Check recipe name for key ingredients
  for (const [key, url] of Object.entries(INGREDIENT_IMAGES)) {
    if (nombre.includes(key)) {
      return url;
    }
  }
  
  // 3. Check main ingredients (first 3)
  const mainIngredients = (recipe.ingredientes || []).slice(0, 3);
  for (const ing of mainIngredients) {
    const ingName = (ing.food_name || ing.nombre || '').toLowerCase();
    for (const [key, url] of Object.entries(INGREDIENT_IMAGES)) {
      if (ingName.includes(key)) {
        return url;
      }
    }
  }
  
  // 4. Default premium placeholder
  return DEFAULT_IMAGE;
};

export default getRecipeImage;
